import React, { useState, useEffect } from "react";
import {
  Button,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  Tooltip,
} from "@mui/material";
import { AccessTime as ClockIcon, Save as SaveIcon } from "@mui/icons-material";
import { useGetTableData2, useCreateData } from "../Plan/tableHooks";
import { toast } from "react-toastify";
import { daysOfWeek, dayTypeMapping } from "./constants";
import * as S from "./styles";
import { CustomButton } from "../../common/Buttons";
import goToHelpLink from "../../../utils/goToHelpLink";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import TPC_URL from "../../../utils/TPC_URL";

function FactoryHours({
  isModal = false,
  selectedDate,
  onClose,
  openSnackbar,
  group_code,
  project_code,
}) {
  const [schedule, setSchedule] = useState({});
  const [selectedPresets, setSelectedPresets] = useState({});
  const [validFrom, setValidFrom] = useState("");
  const [validFromDates, setValidFromDates] = useState({});
  const [scheduleChanges, setScheduleChanges] = useState({
    before: {},
    after: {},
  });
  const { presets } = useGetTableData2(
    true,
    `/api/factory/getTypeM?group_code=${group_code}&project_code=${project_code}`,
    "presets"
  );
  const createMutation = useCreateData(
    true,
    "/api/factory/editOperDay",
    openSnackbar
  );
  useEffect(() => {
    // 현재 설정된 스케줄 가져오기
    const fetchCurrentSchedule = async () => {
      const response = await fetch(
        TPC_URL +
          `/api/factory/getDayM?group_code=${group_code}&project_code=${project_code}`
      );
      const data = await response.json();
      console.log("data.filter : ", data);
      const currentSchedules = data.filter((schedule) => {
        const validTo = new Date(schedule.valid_to);
        return validTo.getFullYear() === 2999;
      });
      const currentSchedule = currentSchedules.sort(
        (a, b) => new Date(b.valid_from) - new Date(a.valid_from)
      )[0];
      if (currentSchedule) {
        const currentPresets = {};
        daysOfWeek.forEach((day) => {
          const typeIdKey = dayTypeMapping[day];
          currentPresets[day] = currentSchedule[typeIdKey];
        });
        setSelectedPresets(currentPresets);
        setScheduleChanges((prev) => ({ ...prev, before: currentPresets }));
      }
    };
    fetchCurrentSchedule();
  }, []);
  const handlePresetChange = (day, presetId) => {
    const selectedPreset = presets.find((preset) => preset.id === presetId);

    if (selectedPreset) {
      setSelectedPresets((prev) => ({
        ...prev,
        [day]: presetId,
      }));
      setSchedule((prev) => ({
        ...prev,
        [day]: {
          presetId,
          presetName: selectedPreset.name,
          schedules: [...selectedPreset.schedules],
        },
      }));
    } else {
      setSelectedPresets((prev) => ({
        ...prev,
        [day]: presetId,
      }));
      setSchedule((prev) => ({
        ...prev,
        [day]: {
          presetId,
          presetName: "휴일",
          schedules: [],
        },
      }));
    }
    setScheduleChanges((prev) => ({
      ...prev,
      after: {
        ...prev.after,
        [day]: presetId,
      },
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!hasAnyChanges()) {
      toast.info("변경된 내용이 없습니다.");
      return;
    }
    const payload = {
      validFrom: validFrom,
      sun_type_id: selectedPresets["일요일"],
      mon_type_id: selectedPresets["월요일"],
      tue_type_id: selectedPresets["화요일"],
      wed_type_id: selectedPresets["수요일"],
      thu_type_id: selectedPresets["목요일"],
      fri_type_id: selectedPresets["금요일"],
      sat_type_id: selectedPresets["토요일"],
      immediateApply: true,
      group_code,
      project_code,
    };
    // if (!immediateApply && !validFrom) {
    //   if (window.confirm("즉시 적용하시겠습니까?")) {
    //     // 즉시 적용하는 logic
    //     payload.immediateApply = true;
    //   } else {
    //     window.alert("적용 날짜를 설정해 주세요.");
    //     return;
    //   }
    // }
    // console.log(scheduleChanges);
    // console.log(schedule);
    // console.log("payload : ", payload);
    // console.log(selectedPresets);
    createMutation.mutate(payload, {
      onSuccess: () => {
        openSnackbar("요일별 가동시간이 설정되었습니다.");
      },
      onError: (error) => {
        const errorMessage =
          error.response?.data?.message || "설정 중 오류가 발생했습니다.";
        openSnackbar(errorMessage, "error");
        console.error(error);
      },
    });
    // immediateApply 체크 =>
    // immediateApply 기존 행의 valid from을 오늘 날짜로 바꾸는 api 실행
    // immediateApply 체크 안되있고 유저가 날짜 선택했으면
    // 새로운 행 insert 하고  + 기존 행 valid to를 유저가 선택한 날짜 -1로 바꿈
    // immediateApply 체크 안되있고 유저가 날짜 선택 x
    // 즉시 적용할거냐고 묻고 즉시적용 ㄱㄱ 아니라고 선택하면 날짜 선택하라고 toast 하고 return;
    // setOpenConfirmDialog(true);
    // setValidFrom(new Date().toISOString().split("T")[0]);
  };
  const hasAnyChanges = () => {
    return daysOfWeek.some(
      (day) => scheduleChanges.before[day] !== scheduleChanges.after[day]
    );
  };
  // const handleConfirmSubmit = async () => {
  //   const payload = {
  //     validFrom: validFrom,
  //     sun_type_id: selectedPresets["일요일"],
  //     mon_type_id: selectedPresets["월요일"],
  //     tue_type_id: selectedPresets["화요일"],
  //     wed_type_id: selectedPresets["수요일"],
  //     thu_type_id: selectedPresets["목요일"],
  //     fri_type_id: selectedPresets["금요일"],
  //     sat_type_id: selectedPresets["토요일"],
  //   };
  //   console.log("payload : ", payload);
  //   // 좀더 고민
  //   // createMutation.mutate(payload, {
  //   //   onSuccess: () => {
  //   //     toast.success("요일별 가동시간이 설정되었습니다.");
  //   //     setOpenConfirmDialog(false);
  //   //     if (onClose) onClose();
  //   //   },
  //   //   onError: (error) => {
  //   //     toast.error("설정 중 오류가 발생했습니다.");
  //   //     console.error(error);
  //   //   },
  //   // });
  // };
  useEffect(() => {
    const fetchCurrentSchedule = async () => {
      try {
        const today = new Date();
        const response = await fetch(
          TPC_URL +
            `/api/factory/getDayM?group_code=${group_code}&project_code=${project_code}`
        );
        const data = await response.json();
        const validSchedule = data.find((schedule) => {
          const validFrom = new Date(schedule.valid_from);
          const validTo = new Date(schedule.valid_to);
          return today >= validFrom && today <= validTo;
        });
        if (validSchedule) {
          const currentPresets = {
            일요일: validSchedule.sun_type_id,
            월요일: validSchedule.mon_type_id,
            화요일: validSchedule.tue_type_id,
            수요일: validSchedule.wed_type_id,
            목요일: validSchedule.thu_type_id,
            금요일: validSchedule.fri_type_id,
            토요일: validSchedule.sat_type_id,
          };
          setSelectedPresets(currentPresets);
          setScheduleChanges((prev) => ({
            before: currentPresets,
            after: currentPresets,
          }));
          const newSchedule = {};
          daysOfWeek.forEach((day) => {
            const typeId = currentPresets[day];
            const preset = presets.find((p) => p.id === typeId);
            if (preset) {
              newSchedule[day] = {
                presetId: typeId,
                presetName: preset.name,
                schedules: [...preset.schedules],
              };
            }
          });
          setSchedule(newSchedule);
          const defaultDates = {};
          daysOfWeek.forEach((day) => {
            defaultDates[day] = new Date().toISOString().split("T")[0];
          });
          setValidFromDates(defaultDates);
        }
      } catch (error) {
        console.error("Error fetching current schedule:", error);
      }
    };
    fetchCurrentSchedule();
  }, [presets]);
  return (
    <S.PageWrapperFacH $isModal={isModal} maxWidth={false}>
      <S.HeaderFacH $isModal={isModal}>
        {!isModal && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "22px !important",
                color: "#111",
              }}
            >
              요일별 근무시간&nbsp;
            </Typography>
            <Tooltip
              title="이동"
              sx={{ cursor: "pointer" }}
              onClick={() =>
                goToHelpLink(
                  "http://esehelp.cafe24.com/scheduler#h-9-4-%EC%9A%94%EC%9D%BC%EB%B3%84-%EA%B0%80%EB%8F%99%EC%8B%9C%EA%B0%84-%EA%B4%80%EB%A6%AC"
                )
              }
            >
              <HelpOutlineIcon />
            </Tooltip>
          </div>
        )}
        {/* {hasAnyChanges() && (
          <div className="date-settings-container">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                opacity: immediateApply ? 0.5 : 1,
                pointerEvents: immediateApply ? "none" : "auto",
              }}
            >
              <Typography variant="subtitle1" style={{ whiteSpace: "nowrap" }}>
                적용 날짜 설정
              </Typography>
              <TextField
                type="date"
                label="적용 시작일"
                value={validFrom}
                onChange={(e) => setValidFrom(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={immediateApply}
                size="small"
              />
            </div>
            <S.CheckboxContainer>
              <S.StyledCheckbox
                checked={immediateApply}
                onClick={() => setImmediateApply(!immediateApply)}
              />
              <Typography
                sx={{
                  opacity: immediateApply ? 0.5 : 1,
                }}
                variant="subtitle1"
              >
                즉시적용
              </Typography>
            </S.CheckboxContainer>
          </div>
        )} */}
        <CustomButton
          type="submit"
          variant="contained"
          startIcon={<SaveIcon />}
          onClick={handleSubmit}
          disabled={!hasAnyChanges()}
          sx={{
            backgroundColor: "#4a90e2",
            color: "white",
            "&:hover": {
              backgroundColor: "#357abd",
            },
            "&.Mui-disabled": {
              backgroundColor: "#e0e0e0",
              color: "#a0a0a0",
              opacity: 0.7,
              cursor: "not-allowed",
              boxShadow: "none",
              "& .MuiSvgIcon-root": {
                color: "#a0a0a0",
              },
            },
          }}
        >
          가동 시간 저장
        </CustomButton>
      </S.HeaderFacH>
      <S.GridFormFacH $isModal={isModal}>
        {daysOfWeek.map((day) => (
          <S.DailyScheduleCardFacH key={day} elevation={2} $isModal={isModal}>
            <S.DayHeaderFacH>
              <S.TitleWithIconFacH>
                <ClockIcon color="primary" />
                <Typography variant="h6">{day}</Typography>
              </S.TitleWithIconFacH>
              <S.PresetSelectFacH>
                <InputLabel>유형 선택</InputLabel>
                <Select
                  value={selectedPresets[day] ?? 0}
                  onChange={(e) => handlePresetChange(day, e.target.value)}
                  label="유형 선택"
                >
                  <MenuItem value={-1}>휴일</MenuItem>
                  {presets.map((preset) => (
                    <MenuItem key={preset.id} value={preset.id}>
                      {preset.name}
                    </MenuItem>
                  ))}
                </Select>
              </S.PresetSelectFacH>
            </S.DayHeaderFacH>
            {schedule[day]?.presetId !== -1 && schedule[day]?.schedules && (
              <S.TimeSlotsFacH>
                {schedule[day].schedules.map((timeSlot, index) => (
                  <S.TimeSlotFacH key={index}>
                    <S.TimeDisplayFacH>
                      <Typography variant="body1" sx={{ fontWeight: 500 }}>
                        {timeSlot.start}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        ~
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 500 }}>
                        {schedule[day].presetId === 0 ? "24:00" : timeSlot.end}
                      </Typography>
                    </S.TimeDisplayFacH>
                  </S.TimeSlotFacH>
                ))}
              </S.TimeSlotsFacH>
            )}
          </S.DailyScheduleCardFacH>
        ))}
      </S.GridFormFacH>
      {/* <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <Typography variant="h6" gutterBottom>
            적용 날짜 설정
          </Typography>
          <TextField
            type="date"
            label="적용 시작일"
            value={validFrom}
            onChange={(e) => setValidFrom(e.target.value)}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "1rem",
              marginTop: "2rem",
            }}
          >
            <Button onClick={() => setOpenConfirmDialog(false)}>취소</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleConfirmSubmit}
            >
              확인
            </Button>
          </div>
        </DialogContent>
      </Dialog> */}
    </S.PageWrapperFacH>
  );
}

export default FactoryHours;
